import { Type } from '@comall-backend-builder/core';
import { formats, modes } from '@comall-backend-builder/types';

import { StringImagePickerPZGFormat } from './format/string/string-image-picker';
import { StringRichTextPZGFormat } from './format/string/string-rich-text';

import { TitleMode } from './mode/string/title';
import { StringVideoPickerMode } from './mode/string/video-picker';
import { StringPointPriceMode } from './mode/string/point-price';
import { StatusBadgeMode } from './mode/string/status-badge';
import { ImageObjectArrayMode } from './mode/array/image-object';
import { PageTemplateMode } from './mode/object/page-template';
import { PageTemplateFormat } from './format/object/page-template';
import { StringReportsReasonMode } from './mode/string/reports-reason';
import { StringReportsUrlMode } from './mode/string/reports-url';
import { StringReportsStatusMode } from './mode/string/reports-status';
import { RowNumberMode } from './mode/number/row-number';
import { MarginRowNumberMode } from './mode/number/marginrow-number';
import { PageColorPickerMode } from './mode/object/page-colorPicker';
import { PageColorPickerFormat } from './format/object/page-colorPicker';
import { BatchDetailAppMode } from './mode/object/batch-detail-app';
import { BatchDetailAppFormat } from './format/object/batch-detail-app';
import { StringRichTextPZGMode } from './mode/string/rich-text';
import { StringShowNameMode } from './mode/string/show-name';

const myTypes = new Map<string, Type>();

myTypes.set('string.text.title', new Type(new formats.StringFormat(), new TitleMode()));
myTypes.set('string.showName', new Type(new formats.StringFormat(), new StringShowNameMode()));
myTypes.set(
    'string.video.picker',
    new Type(new formats.StringFormat(), new StringVideoPickerMode())
);
myTypes.set('string.point.price', new Type(new formats.StringFormat(), new StringPointPriceMode()));
myTypes.set('string.status.badge', new Type(new formats.StringFormat(), new StatusBadgeMode()));
myTypes.set(
    'string.reports.reason',
    new Type(new formats.StringFormat(), new StringReportsReasonMode())
);
myTypes.set('string.reports.url', new Type(new formats.StringFormat(), new StringReportsUrlMode()));
myTypes.set(
    'string.reports.status',
    new Type(new formats.StringFormat(), new StringReportsStatusMode())
);
myTypes.set(
    'string.image.picker.pzg',
    new Type(new StringImagePickerPZGFormat(), new modes.StringImagePickerMode())
);
myTypes.set(
    'array.imageObject',
    new Type(new formats.ArrayNoValidationFormat(), new ImageObjectArrayMode())
);
myTypes.set('object.pageTemplate', new Type(new PageTemplateFormat(), new PageTemplateMode()));
myTypes.set('number.row', new Type(new formats.NumberIntegerFormat(), new RowNumberMode()));
myTypes.set(
    'number.rowmargin',
    new Type(new formats.NumberIntegerFormat(), new MarginRowNumberMode())
);
myTypes.set(
    'object.pageColorPicker',
    new Type(new PageColorPickerFormat(), new PageColorPickerMode())
);
myTypes.set(
    'object.batchDetailApp',
    new Type(new BatchDetailAppFormat(), new BatchDetailAppMode())
);
myTypes.set(
    'string.richText.pzg',
    new Type(new StringRichTextPZGFormat(), new StringRichTextPZGMode())
);

export default myTypes;
